"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lookupIpChargeCorrectionQuerySchema = exports.requestIpChargeCorrectionSchema = exports.previewIpChargeCorrectionSchema = exports.ipChargeCorrectionReplacementSchema = exports.ipChargeCorrectionKindEnum = void 0;
/**
 * IP CHARGE CORRECTION REQUEST — the counter asks for ONE line of an inpatient bill to be corrected or deleted; a verifier and an approver decide
 * it (owner, 2026-10-14: "IP Correction sub tab required… BILL NUMBER should enter and all line items will show and in that each line having
 * option to ask for correction… should see all parameters including delete of that charge line. Then it should go same verify and approval flow").
 *
 * AN APPROVED LINE IS NEVER EDITED IN PLACE — the ledger is append-only (ADR-085). So the request is for one of two acts, and nothing moves until
 * an approver approves it:
 *
 *   CHANGE   the line is REVERSED and a corrected line is added, together, in one transaction;
 *   DELETE   the line is REVERSED and nothing replaces it. The original stays on record, marked Reversed.
 *
 * A CHANGE names the corrected line in full — the SAME inputs the Add line item dialog takes (the charge line, No of Days / Times, the rate of an
 * open-value service, the remarks, the operating team) — and the server prices it exactly as a capture would. Nothing in it is a price.
 */
const zod_1 = require("zod");
const ip_charge_schema_1 = require("../../schemas/ip-charge.schema");
exports.ipChargeCorrectionKindEnum = zod_1.z.enum(['CHANGE', 'DELETE']);
/** The corrected line: the inputs of Add line item, and no source key (the server mints that when the request is approved). */
exports.ipChargeCorrectionReplacementSchema = ip_charge_schema_1.captureIpChargeSchema
    .pick({ serviceId: true, sourceType: true, unitRate: true, description: true, otDoctors: true, chargeGroup: true })
    .extend({ quantity: zod_1.z.number().int().positive().max(10_000) });
/** What the preview takes: the request without the reason (the clerk checks the effect before writing why). */
exports.previewIpChargeCorrectionSchema = zod_1.z.object({
    ledgerId: zod_1.z.string().uuid(),
    kind: exports.ipChargeCorrectionKindEnum,
    /** Required for CHANGE, refused for DELETE — the service says which, in words. */
    replacement: exports.ipChargeCorrectionReplacementSchema.optional(),
});
exports.requestIpChargeCorrectionSchema = exports.previewIpChargeCorrectionSchema.extend({
    reason: zod_1.z.string().trim().min(3, 'A reason is required').max(500),
});
/** Step one of the IP Correction tab: the bill number the desk is holding. */
exports.lookupIpChargeCorrectionQuerySchema = zod_1.z.object({
    billNumber: zod_1.z.string().trim().min(1, 'Enter a bill number').max(30),
});
//# sourceMappingURL=financial-ip-charge-correction.request.js.map